interface SpinnerProps {
    size?: number;
}

export function Spinner({size = 150}: SpinnerProps) {
    return (
        <svg
            fill="none"
            height={size}
            viewBox="0 0 80 80"
            width={size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <style>
                {`
                    .loader-part { animation: pulse 1.5s ease-in-out infinite; }
                    .loader-part-1 { animation-delay: 0s; }
                    .loader-part-2 { animation-delay: 0.2s; }
                    .loader-part-3 { animation-delay: 0.4s; }
                    .loader-part-4 { animation-delay: 0.6s; }
                    @keyframes pulse {
                        0%, 100% { opacity: 0.3; }
                        50% { opacity: 1; }
                    }
                `}
            </style>
            <g transform="translate(5, 5) scale(3)">
                <g clipPath="url(#clip0_loader)">
                    <path
                        className="loader-part loader-part-1"
                        d="M11.7129 3.90332C18.1779 3.90332 23.4254 9.15083 23.4254 15.6159H11.7129V3.90332Z"
                        fill="var(--tt-logo-fill)"
                    />
                    <path
                        className="loader-part loader-part-2"
                        d="M11.7129 19.5205C5.24786 19.5205 0.000349045 14.273 0.000349045 7.80797L11.7129 7.80797L11.7129 19.5205Z"
                        fill="var(--tt-logo-fill)"
                    />
                    <path
                        className="loader-part loader-part-3"
                        d="M19.5205 11.7124C19.5205 18.1774 14.273 23.4249 7.80797 23.4249V11.7124H19.5205Z"
                        fill="var(--tt-logo-fill)"
                    />
                    <path
                        className="loader-part loader-part-4"
                        d="M3.9043 11.7124C3.9043 5.24737 9.1518 -0.000139236 15.6168 -0.000139236V11.7124H3.9043Z"
                        fill="var(--tt-logo-fill)"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_loader">
                    <rect fill="white" height="23.4251" width="23.4251" />
                </clipPath>
            </defs>
        </svg>
    );
}
